var map = {
	"./033-bm.webp": 1380,
	"./033-cn.webp": 1381,
	"./033.webp": 1382,
	"./13-bm.webp": 1383,
	"./13-cn.webp": 1384,
	"./13.webp": 1385,
	"./3-bm.webp": 1386,
	"./3-cn.webp": 1387,
	"./3.webp": 1388,
	"./angpao-bg-mobile.webp": 1389,
	"./angpao-bg.webp": 1390,
	"./angpao-bm.webp": 1391,
	"./angpao-cn.webp": 1392,
	"./angpao.webp": 1393
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1379;